function isValidWord(word) {
  return word.length > 1 && /[a-zA-Z]/.test(word)
}

function firstLetter(str) {
  const match = str.match(/[a-zA-Z]/)
  return match ? match[0] : ''
}

function lastLetter(str) {
  const letters = str.match(/[a-zA-Z]/g)
  return letters?.length ? letters[letters.length - 1] : ''
}

export function abbreviate(name) {
  if (!name?.trim()) return ''

  const words = name.trim().split(/\s+/).filter(isValidWord)
  if (words.length >= 2) {
    return firstLetter(words[0]) + firstLetter(words[1])
  }
  if (words.length === 1) {
    const w = words[0]
    return firstLetter(w) + lastLetter(w)
  }

  return firstLetter(name) || ''
}
